// service/otherChargePaymentService.js
//
// ⚠️ Same note as websitePlanPaymentService.js — adjust authHeaders() if
// your app stores the auth token differently.

import { fetchWrapper } from "utils/apiFetch";



const API_BASE = "https://pro.mokshiq.in";

function authHeaders() {
  const token = localStorage.getItem("token"); // ⚠️ adjust key if different
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function postForm(url, params = {}) {
  const body = new URLSearchParams(params);
  const json = await fetchWrapper(`${API_BASE}/${url}`, {
    method: "POST",
    body,
  });
 
  return json;
}

export const otherChargePaymentService = {
  // Buy any WebsiteOtherCharge item (SSL / domain / SMS pack / UPI / WhatsApp)
  purchase: (chargeId, quantity) =>
    postForm("purchase_other_charge", { charge_id: chargeId, quantity: quantity ?? "" }),

  // History + service status boxes for OtherPaymentHistory.jsx
  getHistory: () => postForm("other_charge_payment_history"),
};